const isBrowser = typeof window !== 'undefined';

const readRaw = (key) => {
  if (!isBrowser) return null;

  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const getStoredValue = (key, fallback = null) => {
  const value = readRaw(key);
  return value ?? fallback;
};

export const setStoredValue = (key, value) => {
  if (!isBrowser) return;

  try {
    if (value === null || value === undefined) {
      window.localStorage.removeItem(key);
      return;
    }

    window.localStorage.setItem(key, String(value));
  } catch {
    // Ignore storage write failures so the UI keeps working.
  }
};

export const getStoredJson = (key, fallback = null) => {
  const raw = readRaw(key);
  if (!raw) return fallback;

  try {
    return JSON.parse(raw);
  } catch {
    if (isBrowser) {
      try {
        window.localStorage.removeItem(key);
      } catch {
        // Ignore cleanup failures.
      }
    }

    return fallback;
  }
};

export const setStoredJson = (key, value) => {
  if (!isBrowser) return;

  try {
    if (value === null || value === undefined) {
      window.localStorage.removeItem(key);
      return;
    }

    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Ignore storage write failures so the UI keeps working.
  }
};

export const removeStoredValue = (key) => {
  if (!isBrowser) return;

  try {
    window.localStorage.removeItem(key);
  } catch {
    // Ignore storage cleanup failures.
  }
};
